/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { trackSearchNext, trackSearchPrev } from "analytics/events";

class SearchResultsIterator {
  constructor(startNode) {
    this.startNode = startNode;
    this.currentNode = this.startNode;
  }

  hasNext() {
    let next = this.currentNode.next;
    if (next.searchResult.equals(this.startNode.searchResult)) {
      return false;
    }
    return true;
  }

  getNext() {
    trackSearchNext();

    this.currentNode = this.currentNode.next;
    return this.currentNode;
  }

  hasPrevious() {
    let previous = this.currentNode.previous;
    if (previous.searchResult.equals(this.startNode.searchResult)) {
      return false;
    }
    return true;
  }

  getCurrent() {
    return this.currentNode;
  }

  getPrevious() {
    trackSearchPrev();

    this.currentNode = this.currentNode.previous;
    return this.currentNode;
  }
}

export { SearchResultsIterator };
